import _ from 'lodash'
import { useMediaQuery } from '@mantine/hooks'
interface MenubarInfoProps {
  name: string | undefined
  curriculumPeriod: string | number | undefined
}

const MenubarInfo = ({ name, curriculumPeriod }: MenubarInfoProps) => {
  const isMobile = useMediaQuery('(max-width: 1023px)')
  return (
    <div className="flex w-full flex-row items-center justify-start gap-2 bg-white px-4 py-2 lg:mt-3 lg:flex-col lg:justify-center lg:p-4">
      <h4 className="text-lg font-semibold text-label-normal lg:text-center lg:text-2xl">
        {name} 님
      </h4>
      <div className="flex flex-row items-center gap-2 lg:justify-center">
        <h6 className="text-sm text-label-alternative">교육기간</h6>
        <p className="text-sm text-primary-normal">
          {typeof curriculumPeriod === 'number' ? `D-${curriculumPeriod}` : curriculumPeriod}
        </p>
      </div>
    </div>
  )
}

export default MenubarInfo
